﻿import * as React from 'react';
import { TranslatedLabels } from '../../../../../shared/types';
import { Translate } from '../../../../../shared/LanguageService';

type NoSearchResultsProps = {
    labels: TranslatedLabels;
};

function NoSearchResults({ labels }: NoSearchResultsProps) {
    return (
        <div className="no-search-result__container">
            <p className="no-search-result__text">{labels.text}</p>
        </div>
    );
}

function NoSearchResultsTranslated() {
    const labels = {
        text: Translate('orders/list/no-search-result')
    };
    return <NoSearchResults labels={labels} />;
}

export default NoSearchResultsTranslated;
